import modalsSlice from './slice'

export default modalsSlice.reducer
